import React, { useState } from "react"

import { useNewsletter } from "@app/hooks/useNewsletter"

import { SubscribeSideWidget } from "@app/components/Subscribe/SubscribeSideWidget"
import SubscribePopup from "@app/components/Subscribe/SubscribePopup"

import type { Location } from "@root/types/global"

type Props = {
  location: Location
}

const Subscribe: React.FC<Props> = ({ location }) => {
  const { active, handleOpen } = useNewsletter(location)
  const [success, setSuccess] = useState(false)

  return (
    <>
      <SubscribePopup {...{ success, setSuccess }} location={location} />
      {active && !success && <SubscribeSideWidget location={location} setOpen={handleOpen} />}
    </>
  )
}

export default React.memo(Subscribe)
